"use client";
import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useState } from "react";
import MobileLogo from '../../..//assets/images/resources/logo-1.png'
import { useAuth } from '../../../context/AuthContext';

const MobileMenu = ({ isSidebar, handleMobileMenu, handleSidebar }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [isActive, setIsActive] = useState({
    status: false,
    key: "",
    subMenuKey: "",
  });

  const handleToggle = (key, subMenuKey = "") => {
    if (isActive.key === key && isActive.subMenuKey === subMenuKey) {
      setIsActive({
        status: false,
        key: "",
        subMenuKey: "",
      });
    } else {
      setIsActive({
        status: true,
        key,
        subMenuKey,
      });
    }
  };

  const handleLogout = async () => {
    handleMobileMenu();
    await logout();
    navigate("/");
  };

  return (
    <>
      {/*End Mobile Menu */}
      <div className="mobile-nav__wrapper">
        <div
          className="mobile-nav__overlay mobile-nav__toggler"
          onClick={handleMobileMenu}
        />
        {/* /.mobile-nav__overlay */}
        <div className="mobile-nav__content">
          <span
            className="mobile-nav__close mobile-nav__toggler"
            onClick={handleMobileMenu}
          >
            <i className="fa fa-times" />
          </span>
          <div className="logo-box">
            <Link to="/" aria-label="logo image">
            <img src={MobileLogo} alt="Logo" />
            </Link>
          </div>
          {/* /.logo-box */}

          {/* লগইন থাকলে নাম + account link, না থাকলে Log in / Sign up */}
          <div style={{ padding: "15px 0", borderBottom: "1px solid rgba(255,255,255,0.1)", marginBottom: "10px" }}>
            {user ? (
              <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                <span style={{ fontWeight: 600 }}>{user.name}</span>
                <Link to="/my-bookings" onClick={handleMobileMenu}>আমার বুকিং</Link>
                <Link to="/my-favorites" onClick={handleMobileMenu}>Favorites</Link>
                <Link to="/notifications" onClick={handleMobileMenu}>Notifications</Link>
                <Link to="/profile" onClick={handleMobileMenu}>প্রোফাইল</Link>
                <button
                  onClick={handleLogout}
                  style={{ background: "none", border: "none", color: "inherit", textAlign: "left", padding: 0, cursor: "pointer" }}
                >
                  Log out
                </button>
              </div>
            ) : (
              <div style={{ display: "flex", gap: "15px" }}>
                <Link to="/login" onClick={handleMobileMenu}>Log in</Link>
                <Link to="/register" onClick={handleMobileMenu}>Sign up</Link>
              </div>
            )}
          </div>

          <div className="mobile-nav__container">
          <ul className="main-menu__list">
  <li>
    <Link to="/" onClick={handleMobileMenu}>
      Home
    </Link>
  </li>

  <li>
    <Link to="/events" onClick={handleMobileMenu}>
      Events
    </Link>
  </li>

  <li>
    <Link to="/about" onClick={handleMobileMenu}>
      About
    </Link>
  </li>

  <li className={isActive.key === 2 ? "dropdown current" : "dropdown"}>
    <Link to="#" onClick={handleMobileMenu}>
      Pages
    </Link>
    <ul style={{ display: `${isActive.key === 2 ? "block" : "none"}` }}>
      <li>
        <Link to="/team" onClick={handleMobileMenu}>
          Team
        </Link>
      </li>
      <li>
        <Link to="/testimonials" onClick={handleMobileMenu}>
          Testimonials
        </Link>
      </li>
      <li>
        <Link to="/pricing" onClick={handleMobileMenu}>
          Pricing
        </Link>
      </li>
      <li>
        <Link to="/gallery" onClick={handleMobileMenu}>
          Gallery
        </Link>
      </li>
      <li>
        <Link to="/faq" onClick={handleMobileMenu}>
          FAQ
        </Link>
      </li>
    </ul>
    <div
      className={isActive.key === 2 ? "dropdown-btn open" : "dropdown-btn"}
      onClick={() => handleToggle(2)}
    >
      <span className="fa fa-angle-right" />
    </div>
  </li>

  <li className={isActive.key === 5 ? "dropdown current" : "dropdown"}>
    <Link to="#" onClick={handleMobileMenu}>
      Blog
    </Link>
    <ul style={{ display: `${isActive.key === 5 ? "block" : "none"}` }}>
      <li>
        <Link to="/blog" onClick={handleMobileMenu}>
          Blog
        </Link>
      </li>
      <li>
        <Link to="/blog-list" onClick={handleMobileMenu}>
          Blog List
        </Link>
      </li>
    </ul>
    <div
      className={isActive.key === 5 ? "dropdown-btn open" : "dropdown-btn"}
      onClick={() => handleToggle(5)}
    >
      <span className="fa fa-angle-right" />
    </div>
  </li>

  <li>
    <Link to="/contact" onClick={handleMobileMenu}>
      Contact
    </Link>
  </li>
</ul>
          </div>
          <ul className="mobile-nav__contact list-unstyled">
            <li>
              <i className="fa fa-envelope" />
              <a href="mailto:support@eventflow.example">
                support@eventflow.example
              </a>
            </li>
            <li>
              <i className="fa fa-phone-alt" />
              <a href="tel:666-888-0000">666 888 0000</a>
            </li>
          </ul>
          {/* /.mobile-nav__contact */}
          <div className="mobile-nav__top">
            <div className="mobile-nav__social">
              <Link to="#" className="fab fa-twitter" />
              <Link to="#" className="fab fa-facebook-square" />
              <Link to="#" className="fab fa-pinterest-p" />
              <Link to="#" className="fab fa-instagram" />
            </div>
            {/* /.mobile-nav__social */}
          </div>
          {/* /.mobile-nav__top */}
        </div>
        {/* /.mobile-nav__content */}
      </div>

      <div
        className="nav-overlay"
        style={{ display: `${isSidebar ? "block" : "none"}` }}
        onClick={handleSidebar}
      />
    </>
  );
};
export default MobileMenu;
